'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _editHtml = require('./edit.html');

var _editHtml2 = _interopRequireDefault(_editHtml);

var _editController = require('./edit.controller');

var _editController2 = _interopRequireDefault(_editController);

function routeConfig($stateProvider) {
	'ngInject';

	$stateProvider
	// Using a '.' within a state name declares a child within a parent.
	// So you have a new state 'Cities' within the parent 'app.private' state.
	.state('app.private.seats.edit', {
		template: _editHtml2['default'],
		controller: _editController2['default'],
		'url': '/edit?lineId',
		'controllerAs': 'vm',
		'resolve': {
			'Line': function Line($state, $filter, $stateParams, LineComponent, Toast) {
				'ngInject';

				return LineComponent.fetchLine($stateParams.lineId, 'translation,stations,buses').then(function (res) {
					if (res.data && res.data.errors) {
						Toast.responseError(res.data.errors);
						$state.go('app.private.seats.chooseLine');
					} else if (!res.buses.length) {
						Toast.error($filter('translate')('NOT_FOUND.BUSES_BY_LINE'));
						$state.go('app.private.seats.chooseLine');
					} else {
						return res;
					}
				});
			}
		}
	});
}

exports['default'] = routeConfig;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/seats/edit/edit.route.js
 **/